import React,{ Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from  '../Vas';
import '../css/SideNavigationOffline.css';

import { Icon,MessageBox } from 'component-lib';

var switchFalgsMobile = false;

class SideNavigation extends Component
{
  constructor(props){
    super(props);
    this.LangConfig = Vas.Config.Languages;
    this.ConfigDataProtection = Vas.Config.DataProtection;
    this.ConfigTermsOfUsage = Vas.Config.TermsOfUsage;
  }

  componentDidMount()
  {
      let me = this;
      let body = $("body");
      //body.css("background-color", "white");
      body.bind("click",function(){
          var burgerMenuClick = localStorage.getItem("BurgerMenu","BurgerMenu");

          if (burgerMenuClick !== "BurgerMenu"){
              
              if(switchFalgsMobile == false) {
                document.getElementById("mySidenavOffline").style.width = "0";
              } else{
                switchFalgsMobile = false;
              }
            }
          else
              {localStorage.setItem("BurgerMenu","");}

          me.setState({});
      });

      $(document).keyup(function(e){

          if (e.which === 27){
              if ($("#mySidenavOffline").length>0)
                  {document.getElementById("mySidenavOffline").style.width = "0";}

          }
      });

      let burgerMenu = $("#Menu");
      //body.css("background-color", "white");        
      burgerMenu.bind("click",function(){

          if (document.getElementById("mySidenavOffline").style.width === "" || document.getElementById("mySidenavOffline").style.width === "0px")
              {
                  document.getElementById("mySidenavOffline").style.width = "auto";
                  localStorage.setItem("BurgerMenu","BurgerMenu");
              }

          me.setState({});
      });
    }
    
    showFlags(){
        $("#MenuItems").removeClass().addClass("languageMenu-items");
    }

    hideFlags(){
        $("#MenuItems").removeClass().addClass("languageMenu-items-notVisible");
    }

    //VAS-30785: Da onMouseOver bzw. onMouseLeave bei mobilen Geräten nicht greift,
    //wurde diese Methode hinzugefügt. Sie wird bei onClick auf Sprache/Langeage getriggert.
    //Das switchFalgsMobile dient als Schalter. Wählbare Sprachen müssen beim 1. Klick angezeigt
    //und beim 2. Klick wieder ausgeblendet werden. Zusätzl. darf das Menü bei Klick auf
    //Sprache/Language nicht geschlossen werden. Erst bai Auswahl der Sprache.
    toggleFlagsMobil(){

      if($("#MenuItems").hasClass("languageMenu-items")){
        $("#MenuItems").removeClass().addClass("languageMenu-items-notVisible");
      } else{
        $("#MenuItems").removeClass().addClass("languageMenu-items");
      }

      switchFalgsMobile = true;
    }

    SetLanguage(lang){
      if(lang === "en"){
        if(this.LangConfig.MessageChangeToEnglish === true){
          ReactDOM.render(<MessageBox 
            AppURL={Vas.ApplicationUrl} 
            Title={Vas.Resources.Titles["Note"]} 
            Message={<div>
              {Vas.Resources.Labels["NoteChangeLanguageGerman"]}
              {<br/>}
              {Vas.Resources.Labels["NoteChangeLanguageEnglish"]}
            </div>}
            Click={()=>{
              localStorage.setItem("vas_language", lang);
              window.location = window.location.pathname;
            }} /> 
            , document.getElementById('messageContainer'));
        }else{
          localStorage.setItem("vas_language", lang);
          window.location = window.location.pathname;
        }
      }else{
        localStorage.setItem("vas_language", lang);
        window.location = window.location.pathname;
      }
    }

    render(){


      let country = '';
      let countryTab = (<tr></tr>);
      if(this.LangConfig.OnlyGerman === false){
        if (localStorage.getItem("vas_language") === "de"){
          country = (<Icon Name={"FlagGermany"} Align={"left"} PaddingTop={"2px"}/>);
        } else {
            country = (<Icon Name={"FlagUnitedKingdom"} Align={"left"} PaddingTop={"2px"}/>);
        }

        countryTab = (<tr>
        <td
          id="LanguageDataLinkOffline"
          onMouseOver={()=>{this.showFlags();}}
          onMouseLeave={()=>{this.hideFlags();}}
          onClick={()=>{this.toggleFlagsMobil();}}>
          {country}
          <div style={{ display:'inline', paddingLeft:'15px' }}>{Vas.Resources.Labels["Language"]}</div>
          {/* <div
            id="MenuItems"
            className={'languageMenu-items-notVisible'}
            style={{ position:'relative', top:'0px' }}>
            <div id="First_Lang" className={"LanguageItem"} onClick={()=>{this.SetLanguage("de");}}>Deutsch</div>
            <div id="Last_Lang" className={"LanguageItem"} onClick={()=>{this.SetLanguage("en");}}>English</div>
          </div> */}
            <div id="First_Lang" className={"LanguageItem"} onClick={()=>{this.SetLanguage("de");}}>Deutsch</div>
            <div id="Last_Lang" className={"LanguageItem"} onClick={()=>{this.SetLanguage("en");}}>English</div>
        </td>
      </tr>);
      }

      let dataProtectionTab = <tr></tr>;
        let tariffTab = <tr></tr>;

      if(this.ConfigDataProtection.Menue === true){
        dataProtectionTab = <tr>
          <td onClick={()=>{ Vas.GetView("DataProtection",null, false); }}>{Vas.Resources.Labels["PrivacyPolicy"]}</td>
        </tr>;

        tariffTab = <tr>
          <td onClick={()=>{ Vas.GetView("TariffData",null, false); }}>{Vas.Resources.Labels["TariffTermsMenue"]}</td>
        </tr> ;
      }

      let termsOfUsageTab = <tr></tr>;
        if(this.ConfigTermsOfUsage.ShowInMenue === true){
          termsOfUsageTab = <tr>
          <td onClick={()=>{ Vas.GetView("TermsOfUsage",null,false);}}>{Vas.Resources.Labels["TermsOfUsage"]}</td>
        </tr>;
        }
        return (<div
          id="mySidenavOffline"
          className="SideNavOffline">
          <table>
            <tbody>
              {termsOfUsageTab}
              <tr>
                <td onClick={()=>{ Vas.GetView("Tariffing",null,false);}}>{Vas.Resources.Labels["PriceInformation"]}</td>
              </tr>
              
              {/*<tr>
                        <td onClick={ ()=>{ Vas.GetView("Webshop",null,false);}}>{Vas.Resources.Menus["Webshop"]}</td>
                    </tr>
                    <tr>
                        <td onClick={ ()=>{ Vas.GetView("Reservation",null,false);}}>{Vas.Resources.Menus["Reservation"]}</td>
                    </tr>*/}
              <tr>
                <td onClick={()=>{ Vas.GetView("Login",null, false); }}>{Vas.Resources.Menus["Login"]}</td>
              </tr>
              <tr>
                <td onClick={()=>{ Vas.GetView("RegisterQuestion",null, false); }}>{Vas.Resources.Menus["Registration"]}</td>
              </tr>
              <tr>
                <td onClick={()=>{ Vas.GetView("FAQ",null, false); }}>{Vas.Resources.Menus["FAQ"]}</td>
              </tr>
              {tariffTab}
              {dataProtectionTab}
              {countryTab}
              <tr>
                <td onClick={()=>{ Vas.GetView("Impressum",null, false); }}>{Vas.Resources.Menus["Impressum"]}</td>
              </tr>
            </tbody>
          </table>
        </div>);
    }
}
export default SideNavigation;
